import React from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import { AuthenticationCredentialsRequest } from '@openapi';
import auth from '@services/api/auth';

import 'react-toastify/dist/ReactToastify.css';
import './login.scss';
import logo from '@assets/images/sage-logo-login.png';
import { toast } from 'react-toastify';
import styles from './login-auth.module.scss';
import { AppContext } from '@layouts/AppRouter';
import { Navigation } from '@constants/Navigation';
import { ApiError } from '@services/types';

function Login() {
  const [form] = Form.useForm<AuthenticationCredentialsRequest>();
  const tokenContext = React.useContext(AppContext);
  const history = useHistory();

  const handleFinish = async (values: AuthenticationCredentialsRequest) => {
    await form.validateFields();
    try {
      const { accessToken } = await auth.login(values);
      if (accessToken) {
        tokenContext.setToken(accessToken);
        tokenContext.setUserLoggedIn(true);
        localStorage.setItem('userLoggedIn', JSON.stringify(true));
      }
    } catch (error: any) {
      if (error?.error?.userId) {
        tokenContext.setUserId(error?.error?.userId);
        toast.error('Password is outdated and needs to be updated');
        setTimeout(() => {
          history.push(Navigation.ChangePassword);
        }, 3000);
      }
      if (error instanceof ApiError) {
        toast.error(error?.error.details);
      } else {
        toast.error('Auth error', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };
  return tokenContext.url === 'default' ? (
    <div className="main-login-page">
      <div className="login-wrapper">
        <img className="login-logo" src={logo} alt="Logo Sagem" />
        <Form className={styles.form} name="normal_login" onFinish={handleFinish} form={form}>
          <Form.Item
            className={styles.block}
            name="username"
            rules={[
              {
                required: true,
                message: 'Please input your Username!',
              },
            ]}
          >
            <Input
              className={styles.input}
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Username"
            />
          </Form.Item>
          <Form.Item
            className={styles.block}
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your Password!',
              },
            ]}
          >
            <Input
              className={styles.input}
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item className="auth-footer">
            <Button className={styles.button} type="primary" htmlType="submit">
              Log in
            </Button>
          </Form.Item>
          <Form.Item>
            <Link className="login-form-forgot" to={Navigation.RecoverPassword}>
              Forgot password
            </Link>
          </Form.Item>
        </Form>
      </div>
    </div>
  ) : (
    <div className="main-login-page">
      <div className="login-wrapper">
        <img className="login-logo" src={logo} alt="Logo Sagem" />
        <Button
          onClick={() => {
            window.location.href = '/saml2/authenticate/sota';
          }}
          style={{ marginTop: '20px' }}
          className={styles.button}
          type="primary"
        >
          Log in with SAML
        </Button>
      </div>
    </div>
  );
}

export default Login;
